(function () {
  // Function to handle the video player setup (YouTube and Vimeo)
  function onVideoPlayerReady() {
    // Each embed-container represents a single video component
    var embedContainers = document.querySelectorAll(".embed-container");

    embedContainers.forEach(function (embedContainer) {
      // Prevent double-init if onVideoPlayerReady runs more than once
      if (embedContainer.dataset.playerInit === "1") return;

      // Read data attributes from the component root
      var platform = embedContainer.dataset.platform;
      var videoId = embedContainer.dataset.videoId;
      if (!platform || !videoId) return;

      // Ensure required APIs are actually ready
      if (platform === "youtube" && (typeof YT === "undefined" || !YT.Player)) return;
      if (platform === "vimeo" && (typeof Vimeo === "undefined" || !Vimeo.Player)) return;

      // Find required child elements within this component
      var thumbnailWrapper = embedContainer.querySelector(".thumbnail-wrapper");
      if (!thumbnailWrapper) return;

      var playBtn = embedContainer.querySelector(".embed-container__play-button");
      if (!playBtn) return;

      var videoPlayerContainer = embedContainer.querySelector(".video-player-container");
      if (!videoPlayerContainer) return;

      var videoPlayer = embedContainer.querySelector(".video-player");
      if (!videoPlayer) return;

      // Mark initialized only after we know we have everything needed
      embedContainer.dataset.playerInit = "1";

      // Handle animation, swap, and execution of play function
      // Prevent double activation
      var isActivating = false;

      function activate(playFn) {
        if (isActivating) return;
        isActivating = true;

        thumbnailWrapper.classList.add("animate");

        setTimeout(function () {
          thumbnailWrapper.style.display = "none";
          videoPlayerContainer.style.display = "block";
          playFn();
        }, 500); // Keep in sync with CSS animation duration
      }

      // Route thumbnail click events through the play button
      // so the button remains the single source of truth for accessibility.
      thumbnailWrapper.addEventListener("click", function (e) {
        if (e.target.closest(".embed-container__play-button")) return;
        playBtn.click();
      });

      // Platform-specific setup
      if (platform === "youtube") {
        // Preload the YouTube player
        var player = new YT.Player(videoPlayer, {
          height: "360",
          width: "640",
          videoId: videoId,
          playerVars: {
            autoplay: 0,
            controls: 1,
          },
        });

        // Button is the canonical control
        playBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          activate(function () {
            player.playVideo();
          });
        });

      } else if (platform === "vimeo") {
        // Preload the Vimeo player
        var player = new Vimeo.Player(videoPlayer, {
          id: videoId,
          width: 640,
          height: 360,
          autoplay: false,
          controls: true,
        });

        // Button is the canonical control
        playBtn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          activate(function () {
            player.play();
          });
        });
      }
    });
  }

  // Check if there are YouTube embeds on the page
  var youtubeEmbeds = document.querySelectorAll(
      ".embed-container[data-platform='youtube']"
    );
  if (youtubeEmbeds.length > 0) {
    // If YouTube API is already loaded, initialize immediately
    if (typeof YT !== "undefined" && YT.Player) {
      onVideoPlayerReady();
    } else {
      // Load the YouTube player API if it's not already injected
      if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        var youtubeTag = document.createElement("script");
        youtubeTag.src = "https://www.youtube.com/iframe_api";
        document.body.appendChild(youtubeTag);
      }

      // Chain any existing YouTube ready handler
      var prevYTReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prevYTReady === "function") prevYTReady();
        onVideoPlayerReady();
      };
    }
  }

  // Check if there are Vimeo embeds on the page
  var vimeoEmbeds = document.querySelectorAll(
    ".embed-container[data-platform='vimeo']"
  );

  if (vimeoEmbeds.length > 0) {
    if (typeof Vimeo !== "undefined" && Vimeo.Player) {
      onVideoPlayerReady();
    } else {
      if (!document.querySelector('script[src="https://player.vimeo.com/api/player.js"]')) {
        var vimeoTag = document.createElement("script");
        vimeoTag.src = "https://player.vimeo.com/api/player.js";
        document.body.appendChild(vimeoTag);
      }

      var checkVimeoApiReady = setInterval(function () {
        if (typeof Vimeo !== "undefined" && Vimeo.Player) {
          clearInterval(checkVimeoApiReady);
          onVideoPlayerReady();
        }
      }, 100);
    }
  }
})();
